module.exports = __webpack_public_path__ + "static/media/payment.7ce209a8.svg";